import { render, staticRenderFns } from "./summarySelection.vue?vue&type=template&id=dc4cd74a&"
import script from "./summarySelection.vue?vue&type=script&lang=js&"
export * from "./summarySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports